import { ReactElement } from 'react';
import * as yup from 'yup';
import { EventChannel } from '../../api/graphql/generated';
import { i18nKeyType } from '../../i18n';

export interface EventIntegrationFormParams {
  onDelete: (channel: EventChannel) => void;
  onRestore: (channel: EventChannel) => void;
  canDelete: boolean;
  canSubmit: boolean;
  channel?: EventChannel;
  deleteDisabled?: boolean;
  submitDisabled?: boolean;
  readOnly?: boolean;
}

export interface EventIntegrationOption {
  FormComponent: ((props: EventIntegrationFormParams) => ReactElement) | null;
  validationSchema: yup.AnySchema | undefined;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  testIntegration?: (formData: any) => Promise<EventIntegrationTestResult>;
}

export enum EventIntegrationServiceType {
  SLACK = 'slack',
}

export interface EventIntegrationServiceDetails {
  name: string;
  label: string; // May need to be i18n...not sure since the integration is most likely a company name
}

export interface EventIntegrationTestStatus {
  error: boolean;
  loading: boolean;
  successMessage?: i18nKeyType;
  errorMessage?: i18nKeyType;
}

export interface EventIntegrationTestResult {
  success: boolean;
  successMessage?: i18nKeyType;
  errorMessage?: i18nKeyType;
}
